import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import SeedTokenTab from './components/SeedTokenTab'

function RobotsPage() {
  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom>
        Robôs
      </Typography>

      <SeedTokenTab />
    </Box>
  )
}

export default RobotsPage
